export enum ServiceSubTypeEnum {
  game = "game",
  streaming = "streaming",
  gameAndStreaming = "game-and-streaming",
  deposit = "deposit",
  additionalTime = "additional-time",
  scoutGame = "scout-game",
}
